import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const HeartAddFill = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.error.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M25.3333 18.6665V22.6665H29.3333V25.3332H25.332L25.3333 29.3332H22.6666L22.6653 25.3332H18.6666V22.6665H22.6666V18.6665H25.3333ZM26.99 6.34315C29.8709 9.23004 30.0952 13.7521 27.6662 16.8893C26.568 16.3204 25.3213 16 23.9998 16C19.5816 16 15.9998 19.5817 15.9998 24C15.9998 25.3452 16.3318 26.6128 16.9184 27.7253L15.9997 28.6467L4.69501 17.324C1.88923 14.1827 1.99411 9.35868 5.00965 6.34315C8.02859 3.3242 12.8601 3.22249 16.0012 6.03804C19.1332 3.22667 23.9732 3.32 26.99 6.34315Z"
        fill={color}
      />
    </svg>
  );
};

export default HeartAddFill;
